export enum SpSelectItems
{
  SPPedagogicalCategories = 'pedagogicalcategories',
  SPRegions = 'regions',
  SPDistricts = 'districts',
  SPInstitutions = 'institutions',
  SpSubjects = 'subjects',
  SpTypePrezidentSchools = 'typeprezidentschools',
  SpEducationLevels = 'educationLevels',
  SpTypeOfPosition = 'typeofpositions',
  SpCategoryOfPosition = 'categoryofpositions',
  SpEducationalOrganization = 'educationalorganizations',
  SpLanguage = 'languages',
  SpApplicantFileTypes = 'applicantfiletypes',
  SpGenders = 'genders',
}
